/* ready */
import Cookies from 'js-cookie';

function load() {
	try {
		return JSON.parse(Cookies.get('_nazoweb2'));
	} catch (ex) {
		return {};
	}
}

function save(data) {
	try {
		Cookies.set('_nazoweb2', JSON.stringify(data), { expires: 365 })
	} catch (ex) {}
}

$(function () {
	'use strict';

	// -- 謎解きチャレンジ --
	const answer01 = ['くま', 'クマ', '熊']
	const answer02 = ['へいわ', 'ヘイワ', '平和'];
	const answer03 = ['HAPPY', 'ＨＡＰＰＹ', 'happy', 'ｈａｐｐｙ', 'Happy', 'Ｈａｐｐｙ', 'はっぴー', 'ハッピー'];
	const answer04 = ['うに', 'ウニ', '雲丹'];
	const answer05 = ['INTERNET', 'ＩＮＴＥＲＮＥＴ', 'internet', 'ｉｎｔｅｒｎｅｔ', 'インターネット', 'いんたーねっと'];
	const answer06 = ['あいかぎ', '合鍵', 'アイカギ'];
	const answer07 = ['正解', 'せいかい', 'セイカイ'];
	const answer08 = ['つき', '月', 'ツキ'];
	const answer09 = ['さんごくし', '三国志', 'サンゴクシ'];

	// 正誤判定
	$('[name="btn01"]').on('click', function () {
		let answer = $('[name="answer01"]').val();
		console.log('aaa')

		if (answer01.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn02"]').on('click', function () {
		let answer = $('[name="answer02"]').val();

		if (answer02.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn03"]').on('click', function () {
		let answer = $('[name="answer03"]').val();

		if (answer03.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn04"]').on('click', function () {
		let answer = $('[name="answer04"]').val();

		if (answer04.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn05"]').on('click', function () {
		let answer = $('[name="answer05"]').val();

		if (answer05.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn06"]').on('click', function () {
		let answer = $('[name="answer06"]').val();

		if (answer06.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn07"]').on('click', function () {
		let answer = $('[name="answer07"]').val();

		if (answer07.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn08"]').on('click', function () {
		let answer = $('[name="answer08"]').val();

		if (answer08.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});
	$('[name="btn09"]').on('click', function () {
		let answer = $('[name="answer09"]').val();

		if (answer09.indexOf(answer) !== -1) {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__cor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__cor2').fadeIn();
		} else {
			$(this).parent().siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__incor').fadeIn();
			$(this).parent().siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__incor2').fadeIn();
		}
	});

	// 答えを見る
	$('.p-nazo__chal__see').on('click', function () {
		$(this).siblings('.p-nazo__chal__quiz').find('.p-nazo__chal__quiz__ans').fadeIn();
	});

	$('.p-nazo__chals__chal__see').on('click', function () {
		$(this).siblings('.p-nazo__chals__chal__quiz').find('.p-nazo__chals__chal__quiz__ans').fadeIn();
	});

	// 閉じる
	$('.p-nazo__chal__quiz__close').on('click', function () {
		$(this).parent().fadeOut();
	});

	$('.p-nazo__chals__chal__quiz__close').on('click', function () {
		$(this).parent().fadeOut();
	});

	$('.p-nazo__chals__chal__quiz__close2').on('click', function () {
		$(this).parent().fadeOut();
	});

	$('.Nazoweb2__start').on('click', function () {
		$('.Nazoweb2').slideDown(function () {
			$('.Nazo_Slides').slick({
				arrows: true,
				dots: false,
				slidesToShow: 1
			});
		});
		$(this).fadeOut();
	});

	var data = load();

	console.log('load', data);

	$('.slick-arrow').text("");

	function getPlaceName(i) {
		if (i === 1) {
			return "高原";
		} else if (i === 2) {
			return "洞窟";
		} else if (i === 3) {
			return "森林";
		} else {
			return "山脈";
		}
	}

	function onChangeSlide(currentSlide) {
		$('.dungeon_1_button').removeClass('selected');
		$('.dungeon_2_button').removeClass('selected');
		$('.dungeon_3_button').removeClass('selected');
		$('.dungeon_4_button').removeClass('selected');

		$('.dungeon_' + (currentSlide + 1) + '_button').addClass('selected');

		var place;

		if (currentSlide === 0) {
			place = "高原";
		} else if (currentSlide === 1) {
			place = "洞窟";
		} else if (currentSlide === 2) {
			place = "森林";
		} else {
			place = "山脈";
		}

		$(".Nazoweb2__title").text(place + "のダンジョン")

		if (data["" + (currentSlide + 1) + "_1"]) {
			$("#nazo" + (currentSlide + 1) + "_1").addClass("clear");
		} else {
			$("#nazo" + (currentSlide + 1) + "_1").removeClass("clear");
			$("#nazo" + (currentSlide + 1) + "_1").removeClass("allclear");
		}

		if (data["" + (currentSlide + 1) + "_2"]) {
			$("#nazo" + (currentSlide + 1) + "_2").addClass("clear");
		} else {
			$("#nazo" + (currentSlide + 1) + "_2").removeClass("clear");
			$("#nazo" + (currentSlide + 1) + "_1").removeClass("allclear");
		}

		if (data["" + (currentSlide + 1) + "_3"]) {
			$("#nazo" + (currentSlide + 1) + "_3").addClass("clear");
		} else {
			$("#nazo" + (currentSlide + 1) + "_3").removeClass("clear");
			$("#nazo" + (currentSlide + 1) + "_1").removeClass("allclear");
		}

		$('.Nazoweb2__body > p').html(place + "に着いたあなた。噂どおり謎解きがある。" +
																	"<br>この謎を全部解けばよいみたいだ。");


		if (window.innerWidth > 767) {
			$('.Nazoweb2__body').css('background-image', 'url("/wp-content/themes/nazoxnazo/images/nazoweb2/select_' + (currentSlide + 1) + '_bg_pc.png")');
		} else {
			$('.Nazoweb2__body').css('background-image', 'url("/wp-content/themes/nazoxnazo/images/nazoweb2/select_' + (currentSlide + 1) + '_bg.png")');
		}

		if (data[place] && data[place] >= 3) {
			$('.Nazo_Clear').show();
			$('.Nazo_Clear > .clear').attr('src', '/wp-content/themes/nazoxnazo/images/nazoweb2/clear_' + (currentSlide + 1) + '.png')
			$('.Nazo_Clear > .tweet').html(place + "の謎を解き明かしたことを投稿しよう！")
			$('.Nazo_Clear > .tweet').attr('href', 'https://twitter.com/intent/tweet?text=謎解きチャレンジ～竜討伐編～' + place + 'のすべての謎を解き明かした！%20' +
																						 'みんなも謎解きに挑戦しよう！%20' +
																						 '%23NAZO劇%20@nazo_rpg%20より&url=https://nazoxnazo.com/nazoweb/')

			$("#nazo" + (currentSlide + 1) + "_1 > img").attr('src', $("#nazo" + (currentSlide + 1) + "_1 > img").attr('src').replace("/wp-content/themes/nazoxnazo/images/nazoweb2/b", "/wp-content/themes/nazoxnazo/images/nazoweb2/nazo"));
			$("#nazo" + (currentSlide + 1) + "_2 > img").attr('src', $("#nazo" + (currentSlide + 1) + "_2 > img").attr('src').replace("/wp-content/themes/nazoxnazo/images/nazoweb2/b", "/wp-content/themes/nazoxnazo/images/nazoweb2/nazo"));
			$("#nazo" + (currentSlide + 1) + "_3 > img").attr('src', $("#nazo" + (currentSlide + 1) + "_3 > img").attr('src').replace("/wp-content/themes/nazoxnazo/images/nazoweb2/b", "/wp-content/themes/nazoxnazo/images/nazoweb2/nazo"));
			$("#nazo" + (currentSlide + 1) + "_1").removeClass("clear");
			$("#nazo" + (currentSlide + 1) + "_2").removeClass("clear");
			$("#nazo" + (currentSlide + 1) + "_3").removeClass("clear");

			$("#nazo" + (currentSlide + 1) + "_1").addClass("allclear");
			$("#nazo" + (currentSlide + 1) + "_2").addClass("allclear");
			$("#nazo" + (currentSlide + 1) + "_3").addClass("allclear");

			$('.Nazoweb2__body > p').html("他のダンジョンに挑戦しよう！");
			$('.Nazoweb2__body > p').addClass('clear');
		} else {
			$('.Nazo_Clear').hide();
			$('.Nazoweb2__body > p').removeClass('clear');
		}
	}

	onChangeSlide(0);

	$(window).on('resize', function () {
		onChangeSlide($('.Nazo_Slides').slick('slickCurrentSlide'));
		refresh();
	});

	$('.Nazo_Slides').on('afterChange', function (event, slick, currentSlide) {
		onChangeSlide(currentSlide);
	});

	$('.dungeon_1_button').on('click', function () {
		onChangeSlide(0);
		$('.Nazo_Slides').slick('slickGoTo', 0);
	});

	$('.dungeon_2_button').on('click', function () {
		onChangeSlide(1);
		$('.Nazo_Slides').slick('slickGoTo', 1);
	});

	$('.dungeon_3_button').on('click', function () {
		onChangeSlide(2);
		$('.Nazo_Slides').slick('slickGoTo', 2);
	});

	$('.dungeon_4_button').on('click', function () {
		onChangeSlide(3);
		$('.Nazo_Slides').slick('slickGoTo', 3);
	});

	var ANS = [
		[
			'ゆり', 'ひとまとめ', 'けいげん',
		],
		[
			'ぶんれつ', 'おうむがえし', 'きんこ'
		],
		[
			'はてな', 'しゅつば', 'いくさ'
		],
		[
			'たんけん', 'きんかくじ', 'からふる'
		],
		[
			'こうげき'
		],
		[
			'こうりゃく'
		]
	]

	function allClear() {
		// return true;
		return (data["高原"] && data["高原"] >= 3) && (data["洞窟"] && data["洞窟"] >= 3) && (data["森林"] && data["森林"] >= 3) && (data["山脈"] && data["山脈"] >= 3);
	}

	function refresh() {
		if (allClear()) {
			var suffix = window.innerWidth > 767 ? "_pc" : "";
			$('.Nazoweb2__castle').show();
			$('.Nazoweb2__castle_title').show();
			if (data["攻略"]) {
				$('#dragon').hide();
				$('.Nazoweb2__castle').hide();
				$('.Nazoweb2__castle__clear').show();
				$('.Nazoweb2__castle_title').hide();
			} else if (data["タップ"] && data["タップ"] >= 10) {
				$('#dragon').hide();
				$('.Nazoweb2__castle > img').attr('src', '/wp-content/themes/nazoxnazo/images/nazoweb2/castle_4' + suffix + '.png');
				$('.CastleNazo > .nazo_img > img').attr('src', '/wp-content/themes/nazoxnazo/images/nazoweb2/6_1.png');
			} else if (data["攻撃"]) {
				$('#dragon').show();
				$('.Nazoweb2__castle > img').attr('src', '/wp-content/themes/nazoxnazo/images/nazoweb2/castle_3' + suffix + '.png');
			} else {
				$('#dragon').show();
				$('.Nazoweb2__castle > img').attr('src', '/wp-content/themes/nazoxnazo/images/nazoweb2/castle_2' + suffix + '.png');
				if ($('#Castle').length) {
					scrollTo("#Castle");
				}
			}
		}
	}

	refresh();

	function verify(i, j, ans) {
		var answer = ANS[i-1][j-1].split(",");
		for (i = 0; i < answer.length; i++) {
			if (answer[i] === ans) {
				return true;
			}
		}
		return false;
	}

	$('.slide > div > div').on('click', function () {
		var src = $(this).attr('id').replace('nazo', '');

		$('.NazoPopup > .img > img').attr('src', "/wp-content/themes/nazoxnazo/images/nazoweb2/nazo" + src + ".png");
		$('.NazoPopup').fadeIn();

		var nums = src.split("_");

		var i = parseInt(nums[0], 10);
		var j = parseInt(nums[1], 10);

		if (data[src]) {
			$('.NazoPopup').addClass('clear');
			$('.NazoPopup > .img').addClass('clear');
			$(".NazoPopup > div > input").val(data[src]);
			$(".NazoPopup > div > input").attr('disabled', 'true');
			$('.NazoPopup > div > .tweet').attr('href', 'https://twitter.com/intent/tweet?text=謎解きチャレンジ～竜討伐編～' + getPlaceName(i) + 'の謎【第' + j + '問】をクリアした！%20' +
																									'みんなも謎解きに挑戦しよう！%20' +
																									'%23NAZO劇%20@nazo_rpg%20より&url=https://nazoxnazo.com/nazoweb/')
		} else {
			$('.NazoPopup').removeClass('clear');
			$('.NazoPopup > .img').removeClass('clear');
			$(".NazoPopup > div > input").val("");
			$(".NazoPopup > div > input").removeAttr('disabled');
		}

		$(".NazoPopup > div > .hint").off();
		$(".NazoPopup > div > .hint").on("click", function () {
			showHint(i, j);
		});

		$(".NazoPopup > div > .answer").off();
		$(".NazoPopup > div > input").off();

		function answer() {
			var ans = $(this).parent().children('input').val();

			if (verify(i, j, ans)) {
				$('.p-pop > div > .hint').hide();
				$('.p-pop > div > .correct').show();
				$('.p-pop > div > .incorrect').hide();
				$('.p-pop').fadeIn();
				if (!data[getPlaceName(i)]) {
					data[getPlaceName(i)] = 1;
				} else if (!data[src]) {
					data[getPlaceName(i)] = data[getPlaceName(i)] + 1;
				}
				data[src] = ans;
				save(data);

				$('.p-pop > div > .correct > div > div > .tweet').attr('href', 'https://twitter.com/intent/tweet?text=謎解きチャレンジ～竜討伐編～' + getPlaceName(i) + 'の謎【第' + j + '問】をクリアした！%20' +
																																			 'みんなも謎解きに挑戦しよう！%20' +
																																			 '%23NAZO劇%20@nazo_rpg%20より&url=https://nazoxnazo.com/nazoweb/')
				$('.NazoPopup').fadeOut();
				onChangeSlide(i - 1);
				refresh();
			} else {
				$(this).parent().children('input').val("");
				$('.p-pop > div > .hint').hide();
				$('.p-pop > div > .correct').hide();
				$('.p-pop > div > .incorrect').show();
				$('.p-pop').fadeIn();
			}
		}

		$(".NazoPopup > div > .answer").on("click", function (e) {
			e.preventDefault();
			answer.bind($(this))();
		});
		$(".NazoPopup > div > input").keypress(function(e) {
			if (e.keyCode == 13) {
				answer.bind(this)();
				return false;
			}
		});
	});

	function scrollTo(id) {
		var target = $(id);
		var position = target.offset().top;
		$('body,html').not(':animated').animate({ scrollTop: position }, 300, 'swing');
	}

	$('.NazoPopup > .close').on('click', function () {
		$('.NazoPopup').fadeOut();
	});

	var HINT = [
		[
			"イラストはそれぞれ「びょういん」「びよういん」「はくさい」「はくい」「きゅうり」です。丸の中に紛れた２つのアイテムによって、言葉が変換されるようです。\n" +
			"２つのアイテムは「虫眼鏡」と「遮眼子（視力検査で使う眼をふさぐもの）」です。",

			"それぞれの丸で囲まれた文字を、言葉で表しましょう。\n" +
			"一番上の丸は「ひ」と「で」が囲まれ、一番下の丸は「め」と「ろ」が囲まれています。\n" +
			"真ん中の丸は、何と何と何が囲まれているでしょうか。",

			"一番上の緑枠には「８」が入り、真ん中の緑枠には「８」が横になったものが入ります。\n" +
			"また、右のマーク１つにひらがな１文字が当てはまります。\n" +
			"そして、それぞれ左が示すものを、右では言葉で表しているようです。\n" +
			"一番下は「さん」が当てはまります。",
		],
		[
			"バラバラになった漢字を合体させましょう。\n" +
			"「バラバラ」を意味する二字熟語が完成します。",

			"上の青い枠は「言ったことがそのまま返される」、下の赤い枠は「あるひらがなが、あるひらがなに変換されている」状態です。\n" +
			"これらを共通して表す、ひらがな６文字を考えましょう。",

			"２つのシルエットを組み合わせて指定されたモノを作りましょう。\n" +
			"そして、そのシルエットの上に書かれた文字を矢印に従い、左から右へと読みましょう。\n" +
			"すると「カイ・テン」「シ・ゲキ」と言葉を作ることができます。\n" +
			"鉛筆を作るには、謎全体を見る必要がありそうです。",
		],
		[
			"３行の頭の文字を順に読むと、文に書かれた通り「こあら」となります。\n" +
			"同じように考えましょう。",

			"「かいへい」は漢字にすると「開閉」のようです。\n" +
			"「門」という漢字が「入」ることで、「入門」となるようです。\n" +
			"「きばせん」から何という漢字が「出」てしまっているでしょうか。\n" +
			"それを二字熟語で表しましょう。",

			"上下それぞれの形をカナ４文字で表し、形に１文字ずつ対応させましょう。\n" +
			"イコールで繋がれた部分は同じカナが入ります。\n" +
			"また、上下それぞれの形の１つ目には「さ」が入ります。"
		],
		[
			"下の四角にはそれぞれひらがな１文字が入るようです。\n" +
			"同じ色の四角の一部分を見たとき何というひらがなに見えるか考えましょう。\n" +
			"例えば、左端の四角は「こ」を表しているようです。",

			"「③①＝かき」と対応していることや、何かを聞いて答えている対応の様子から、①～⑤にひらがなを当てはめましょう。⑤には「じ」が当てはまります。",

			"品詞やイラストを頼りに文字を当てはめます。\n" +
			"「③゛④―」は色を表しているようです。"
		],
		[
			"４つのダンジョンから１つずつ「○○げ○」「○○○つ」「し○○○」「○ん○○○」に当てはまる答えを探して埋めましょう。\n" +
			"①～⑤を続けて読むと、ある指示が現れます。",

			"①～⑤を続けて読むと「けんつくれ」となります。\n" +
			"「つくれ」という指示がある謎が、今までに登場しています。\n" +
			"その謎のルールに従い、剣を作りましょう。"
		],
		[
			"下のマスに「４つのダンジョン」を当てはめると最後の答えが導けるようです。\n" +
			"「４つのダンジョン」とは何を指しているか考えましょう。",

			"これまでの冒険を振り返ってみましょう。\n" +
			"あなたはここに当てはまる４つのダンジョンを必ず目にしているはずです。"
		]
	];

	// けんつくれ

	function showHint(i, j) {
		var hint = HINT[i-1][j-1].replaceAll("\n", "<br>");
		$('.p-pop > div > .hint').html(hint);
		$('.p-pop > div > .incorrect').hide();
		$('.p-pop > div > .correct').hide();
		$('.p-pop > div > .hint').show();
		$('.p-pop').fadeIn();
	}

	$('.p-pop > div > .close').on('click', function () {
		$('.p-pop').fadeOut();
	});

	function answerCastle() {
		var ans = $(this).parent().children('input').val();
		if (!data["攻撃"]) {
			if (verify(5, 1, ans)) {
				$(this).parent().children('input').val("");
				data["攻撃"] = 1;
				data["タップ"] = 0;
				save(data)
				refresh();
				scrollTo("#Castle");
			} else if (ans === "けんつくれ" || ans === "剣を作れ" || ans === "ケンヲツクレ") {
				$(this).parent().children('input').val("");
				$('.p-pop > div > .hint').html("その指示を実際にやってみよう！");
				$('.p-pop > div > .incorrect').hide();
				$('.p-pop > div > .correct').hide();
				$('.p-pop > div > .hint').show();
				$('.p-pop').fadeIn();
			} else {
				$(this).parent().children('input').val("");
				$('.p-pop > div > .hint').hide();
				$('.p-pop > div > .correct').hide();
				$('.p-pop > div > .incorrect').show();
				$('.p-pop').fadeIn();
			}
		} else if (!data["タップ"] || data["タップ"] < 10) {
			$(this).parent().children('input').val("");
			$('.p-pop > div > .hint').hide();
			$('.p-pop > div > .correct').hide();
			$('.p-pop > div > .incorrect').show();
			$('.p-pop').fadeIn();
		} else {
			if (verify(6, 1, ans)) {
				$(this).parent().children('input').val("");
				data["攻略"] = 1;
				save(data);
				refresh();
				scrollTo("#Castle");
			} else {
				$(this).parent().children('input').val("");
				$('.p-pop > div > .hint').hide();
				$('.p-pop > div > .correct').hide();
				$('.p-pop > div > .incorrect').show();
				$('.p-pop').fadeIn();
			}
		}
	}

	$('.CastleNazo > .answer').on('click', answerCastle);
	$(".CastleNazo > input").keypress(function(e) {
		if (e.keyCode == 13) {
			answerCastle.bind(this)();
			return false;
		}
	});

	$('.CastleNazo > .hints > .hint1').on('click', function () {
		if (!data["タップ"] || data["タップ"] < 10) {
			showHint(5, 1);
		} else {
			showHint(6, 1);
		}
	});

	$('.CastleNazo > .hints > .hint2').on('click', function () {
		if (!data["タップ"] || data["タップ"] < 10) {
			showHint(5, 2);
		} else {
			showHint(6, 2);
		}
	});

	function doKougeki() {
		if (!data["攻撃"]) {
			return
		}

		if (data["タップ"] >= 10) {
			return
		}

		$("#dragon").fadeOut(100, function(){ $(this).fadeIn(100, function () {
			$("#dragon").fadeOut(100, function(){ $(this).fadeIn(100, function () {
				if (data["タップ"] >= 10) {
					$("#dragon").hide();
				}
			})});
		})});

		var random = Math.floor(Math.random() * 100000);
		var $gif = $("<img src=\"/wp-content/themes/nazoxnazo/images/nazoweb2/effect.gif?v=" + random + "\">");
		var rotate = Math.floor(Math.random() * 360);
		$gif.css("transform", "rotate(" + rotate + "deg)")
		$('.effect').append($gif);
		data["タップ"] = data["タップ"] + 1;
		save(data);

		if (data["タップ"] >= 10) {
			$("#dragon").hide();
			refresh();
		}
	}

	$('#dragon').on("click", doKougeki);

	$('.effect').on("click", doKougeki);

	$('.effect > img').on("click", doKougeki);
});
